import Dropdown from "./Dropdown";

const FormSelectOptions = ({
                             tiendas,
                             setTiendas,
                             category,
                             categoryList,
                             setCategory,
                             misProductos, // Viene del padre
                             setMisProductos, // Viene del padre
                             relevamientoIniciado,
                             gondolaEnabled,
                             etiquetaEnabled,
                           }) => {

  // OPCIONES ESTÁTICAS
  const optionsRelevamiento = {};
  if (etiquetaEnabled) optionsRelevamiento['0'] = 'Relevamiento por etiquetas';
  if (gondolaEnabled)  optionsRelevamiento['1'] = 'Relevamiento de góndola';

  return (
      <div>
        <div className="form-group">
          <Dropdown
              options={tiendas}
              disabled={relevamientoIniciado}
              onSelect={setTiendas}
              label="Tienda"
          />
        </div>

        {gondolaEnabled && etiquetaEnabled && (
            <div className="form-group">
              <Dropdown
                  disabled={relevamientoIniciado}
                  options={optionsRelevamiento}
                  onSelect={(val) => {
                    // Simplemente le pasamos el valor al padre
                    const esGondola = String(val) === '1';
                    setMisProductos(esGondola);
                  }}
                  // Le pasamos el valor actual para que el Dropdown se mantenga visualmente
                  value={misProductos ? '1' : '0'}
                  label="Clase de relevamiento"
              />
            </div>
        )}

        {/* Solo mostramos categorías si el estado del PADRE es true */}
        {misProductos === true && (
            <div className="form-group">
              <Dropdown
                  options={categoryList}
                  onSelect={setCategory}
                  label="Categoría"
                  disabled={relevamientoIniciado}
              />
            </div>
        )}
      </div>
  );
};

export default FormSelectOptions;